<template>
    <el-row>
      <el-col :span="24">
      </el-col>
      <el-button style="margin-bottom: 10px;" type="primary" size="mini" @click="newCompanyDialogOpen()">{{ $t('company.new', { msg: 'company.new' }) }}</el-button>
    </el-row>
    
    <el-table tooltip-effect="dark"
             border
             stripe
             highlight-current-row
            style="width: 100%"
            :data="companyList"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
        <!-- <el-table-column :label="$t('company.id', { msg: 'company.id' })" prop="companyID"></el-table-column> -->
        <el-table-column :label="$t('company.companyName', { msg: 'company.companyName' })" prop="companyname"></el-table-column>
        <el-table-column :label="$t('company.companyIden', { msg: 'company.companyIden' })" prop="identifier"></el-table-column>
     <el-table-column :label="$t('company.opr', { msg: 'company.opr' })" width="150">
        <template #default="scope">
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              :disabled="deleteBtn">{{ $t('company.delete', { msg: 'company.delete' }) }}</el-button>
        </template>
      </el-table-column> 
    </el-table>

    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5,10, 20]"
      :page-size="pageSize"
      :total="totalItems"
      layout="sizes, total, prev, pager, next, jumper"
    ></el-pagination>



    <el-dialog
        :title="$t('company.new', { msg: 'company.new' })"
        :modelValue="newCompanyDialogVisible"
        width="70%"
        :before-close="newCompanyDialogClose">
    <el-form ref='companyForm' :rules="rules" :model="companyForm" label-width="180px">
      <el-form-item :label="$t('company.companyName', { msg: 'company.companyName' })" prop="companyname">
          <el-input type="text"  maxlength="12" show-word-limit :placeholder="$t('company.companyNameD', { msg: 'company.companyNameD' })" v-model="companyForm.companyname"></el-input>
        </el-form-item>
        <el-form-item :label="$t('company.companyIden', { msg: 'company.companyIden' })" prop="identifier">
          <el-input type="text" maxlength="8" show-word-limit :placeholder="$t('company.companyIdenD', { msg: 'company.companyIdenD' })" v-model="companyForm.identifier"></el-input>
      </el-form-item>

      <el-form-item>
      <el-button type="primary" @click="addCompany()">{{ $t('company.confirm', { msg: 'company.confirm' }) }}</el-button>
      <el-button type="danger" @click="resetForm('companyForm')">{{ $t('company.reset', { msg: 'company.reset' }) }}</el-button>
    </el-form-item>
    </el-form>
    </el-dialog>
  </template>
  
  <script>
  import axios from "axios";
  import { baseUrl_New } from '../../axios/urlconfig';
  import { ElMessage } from "element-plus";
import { getRequest, postRequest } from '../../axios/axios';

  export default {
    name: "usercompany",
    props: ['companyId','companyname','identifier'],
    created(){
      this.loadData();
    },
    data() {
      return{
        currentCompanyList: [], // 当前显示的数据页
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页显示的数据条数
        totalItems: 0, // 总数据量
        newCompanyDialogVisible: false,
        companyList: [],
        companyForm:{
          companyId: 0,
          companyname: '',
          identifier: ''
        },
        rules: {
        companyname: [
          { required: true, message: this.$t('company.companyNameD', { msg: 'company.companyNameD' }), trigger: 'blur' },
          { min: 1, max: 12, message:  this.$t('company.comlinitlen', { msg: 'company.comlinitlen' }), trigger: 'blur' }
        ],
        identifier: [
          { required: true, message: this.$t('company.companyIdenD', { msg: 'company.companyIdenD' }), trigger: 'blur' },
          { min: 3, max: 8, message: this.$t('company.idenlimitlen', { msg: 'company.idenlimitlen' }), trigger: 'blur' }
        ],
      },
      deleteBtn: false
      }
    },

    updated(){
      this.buttonCheck();
    },

    methods:{
    buttonCheck(){
      if(sessionStorage.getItem('username') !== 'admin'){
        //console.log(this.deleteBtn);
        this.deleteBtn = true;
      }
    },
    
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.loadData();
    },

     // 处理分页组件的每页显示条数改变事件
     handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.loadData();
    },

     // 更新当前显示的数据页
     updateCurrentCompanyList() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      this.currentCompanyList = this.companyList.slice(startIndex, endIndex);
    },

    loadData() {
      const pageNum = this.currentPage;
      const pageSize = this.pageSize;
      const params = { pageNum, pageSize };
      getRequest(baseUrl_New + '/company/list',  params ).then(response => {
        // console.log(response);
        this.companyList = response.list; // 确保数据在 response.data.list 中
        this.totalItems = response.total; // 确保总数据量在 response.data.total 中
        this.updateCurrentCompanyList(); // 加载数据后更新当前显示的数据页
      });
    },

    addCompany(){
        this.$refs.companyForm.validate((valid) => { 
        if (valid) {
          postRequest(baseUrl_New + '/company/insert', this.companyForm, {
          headers: {
            'Content-Type': 'application/json' // 设置请求头为 JSON 格式
          }
        })
        .then(response => {
          console.log(response)
          if(response.message === '新增成功'){
            ElMessage.success(this.$t('issue.addS', { msg: 'issue.addS' }));
            this.resetForm('companyForm');
            this.newCompanyDialogClose();
            this.loadData();   
          }
          if(response.message === '新增失败'){
            ElMessage.error(this.$t('issue.addF', { msg: 'issue.addF' }));
          }
        })
        .catch(error => {
          console.log("console log: " + error);
          ElMessage.error(this.$t('issue.addF', { msg: 'issue.addF' }));
        });
        }
      });
    },

      resetForm(formName) {  //重置表单
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields();
        }              
      },

      handleDelete(index, row) { //删除按钮
        this.openConfirm(row);
      },

      newCompanyDialogClose(){ //关闭新增公司对话框
        this.newCompanyDialogVisible = false;
      },

      newCompanyDialogOpen(){  //开启新增公司对话框
        this.newCompanyDialogVisible = true
      },

      openConfirm(row) {
        const companyID = row.companyID;
        this.$confirm(this.$t('company.info', { msg: 'company.info' }), this.$t('issue.tips', { msg: 'issue.tips' }), {
          confirmButtonText: this.$t('exportIssue.confirm', { msg: 'exportIssue.confirm' }),
          cancelButtonText: this.$t('exportIssue.cancel', { msg: 'exportIssue.cancel' }),
          cancelButtonClass: 'btn-custom-cancel',
          type: 'warning'
        }).then(() => {
          postRequest(baseUrl_New + '/company/delete', { companyId: companyID })
          .then(response => {
            if (response === '删除成功') {
              this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));
              const index = this.companyList.findIndex(item => item.companyID === companyID);
              if (index !== -1) {
                this.companyList.splice(index, 1);
              }
            } else {
              this.$message.error(this.$t('company.deleteS', { msg: 'company.deleteS' }));
            }
          })
          .catch(error => {
            console.error('删除失败：', error);
            this.$message.error(this.$t('company.deleteS', { msg: 'company.deleteS' }));
          });
        })
      },
    }
  }
  </script>
  
  <style scoped>
  .btn-custom-cancel {
  float: right;
  margin-left: 10px;
}
  </style>